module.exports = __webpack_public_path__ + "static/media/eye-icon.f381c3f2.svg";